import { FaTrash } from 'react-icons/fa'

const TableTwo = ({ tertiary, setTertiary }) => {

    const removeLevel = (record) => {
        
        let newTertiaryLevel = tertiary.filter((level) => {
            return level.course !== record.course ;
        });
        setTertiary(newTertiaryLevel);
    }
    
    return ( 
        <>
            <table className="mt-6">
                <thead>
                    <tr>
                        <th>Level Attained</th>
                        <th>Course Title</th>
                        <th>Year Obtained</th>
                        <th> </th>
                    </tr>
                    </thead>
                    <tbody>
                        {
                            tertiary && tertiary.map(record => (
                                <tr key={ record.course}>
                                    <td>{ record.tertiaryLevel }</td>
                                    <td>{ record.course }</td>    
                                    <td>{ record.tertiaryYear }</td>    
                                    <td><FaTrash color="#af0e19" 
                                        onClick={() => removeLevel(record)}
                                    /></td>   
                                </tr>
                            ))
                        }             
                </tbody>
            </table>
        </>
     );
}
 
export default TableTwo;
